var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnItalic = function SvgIcnItalic(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2601 9H14.2601L12.0601 19H10.0601L12.2601 9ZM13.9401 5C13.7423 5 13.5489 5.05865 13.3845 5.16853C13.22 5.27841 13.0919 5.43459 13.0162 5.61732C12.9405 5.80004 12.9207 6.00111 12.9593 6.19509C12.9979 6.38907 13.0931 6.56725 13.233 6.70711C13.3728 6.84696 13.551 6.9422 13.745 6.98079C13.9389 7.01937 14.14 6.99957 14.3227 6.92388C14.5055 6.84819 14.6616 6.72002 14.7715 6.55557C14.8814 6.39112 14.9401 6.19778 14.9401 6C14.9401 5.73478 14.8347 5.48043 14.6472 5.29289C14.4596 5.10536 14.2053 5 13.9401 5Z",
    fill: "currentcolor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnItalic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_italic.1d0464d2.svg";
export { ForwardRef as ReactComponent };